export const TopLinks = [
    {
        id:"6145026c08a04b12048caa84",
        category:"Men's Dress",
        image:"assets/top/career_progress.svg",
        url:"man's"
    },
    {
        id: "6145029508a04b12048caa88",
        category: "Women's  Dress",
        image:"assets/top/window_shopping.svg",
        url:"women's"

    },
    {
        id:"614502a308a04b12048caa8b",
        category:"Jewelery",
        image:"assets/top/jewelry.svg",
        url:"jewelery"
    
    }
]